import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
//import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pdf } from "@react-pdf/renderer";
import Corporate_Inquiry_Report from './Document/Corporate_Inquiry_Report';

const CorporateInquiry = () => {

    const [course, setCourse] = useState([])
    const [value, setValue] = useState({
        Course_Id: '',
    })
    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    useEffect(() => {
        getCourseData()
    }, [])

    const [pdfdata, setpdfData] = useState([]);

    async function getDetails() {
        const param = {
            Course_Id: value.Course_Id,
            fromdate: value.fromdate,
            todate: value.todate
        };

        axios.post(`${BASE_URL}/getcorporateinquiryreport`, param).then((res) => {
            if (res.data.length === 0) {
                alert("No record found");
                return; // stop further execution
            }

            setpdfData(res.data);
            corporateinquiryreport(res.data);
        }).catch((err) => {
            console.error("Error fetching data:", err);
            alert("Something went wrong while fetching the data.");
        });
    }



    const corporateinquiryreport = async (data) => {
        const blob = await pdf(<Corporate_Inquiry_Report data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };



    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    return (

        <div class="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Corporate Inquiry</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3">
                                        <div class='row'>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option>Select Course</option>
                                                    {course.map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                        )
                                                    })}
                                                </select>
                                            </div>


                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                <label for="exampleInputUsername1">From Date</label>
                                                <DatePicker
                                                    selected={value.fromdate ? new Date(value.fromdate) : null}
                                                    onChange={(date) =>
                                                        onhandleChange({ target: { name: "fromdate", value: date } })
                                                    }
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select From Date"
                                                />

                                            </div>

                                            <div class="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                <label for="exampleInputUsername1">To Date</label>
                                                <DatePicker
                                                    selected={value.todate ? new Date(value.todate) : null}
                                                    onChange={(date) =>
                                                        onhandleChange({ target: { name: "todate", value: date } })
                                                    }
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select To Date"
                                                />

                                            </div>

                                        </div>




                                        <button
                                            type="button"
                                            onClick={getDetails}
                                            class="btn btn-primary mr-2"
                                            disabled={
                                                !value.Course_Id ||
                                                value.Course_Id === "Select Course" ||
                                                !value.fromdate ||
                                                !value.todate
                                            }>
                                            Show
                                        </button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-primary">Back</button>



                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default CorporateInquiry
